import React from 'react';
import PropTypes from 'prop-types';

export const Banner = ({
  images,
  resize,
  ...props
}) => {
  return (
    <div className="Banner">
      <img
        className={`Banner__media is-${resize}`}
        srcSet={`${images.mobile} 1024w, ${images.desktop}`}
        {...props}
      />
    </div>
  )
};

Banner.propTypes = {
  images: PropTypes.object.isRequired,
  resize: PropTypes.oneOf(['cover', 'contain'])
};

Banner.defaultProps = {
  images: undefined,
  resize: 'cover'
};
